const data = {
    calc: {
        expression: "0",
        output: "0",
        grandTotal: false
    },
    clear: "C",
    negative: "±",
    mod: "%",
    divide: "/",
    seven: "7",
    eight: "8",
    nine: "9",
    multiply: "*",
    four: "4",
    five: "5",
    six: "6",
    subtract: "-",
    one: "1",
    two: "2",
    three: "3",
    add: "+",
    decimal: ".",
    zero: "0",
    delete: "DEL",
    equals: "="
};

export default data;
